export default {
  saldo_payment_gateway: [
    {
      category: 'saldo',
      code: 'saldo',
      created_at: '',
      file: '/zx.png',
      gateway: 2,
      id: 0,
      is_enabled: 1,
      max_transaction: 100000000,
      min_transaction: 50000,
      name: 'Saldo ZAXPAY',
      tutorial: [],
      updated_at: ''
    }
  ],
  va_payment_gateway: [],
  other_payment_gateway: [],
  payment_gateway: [],
  selectedPayment: null

}